import { soundManager } from './SoundManager';

export const playRandomPopSound = (muted) => {
    if (muted) return;
    soundManager.playRandomPop();
};

export const playBumpSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('bump', 0.6);
};

export const playGameOverSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('gameover');
};

export const playCollectSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('collect', 0.7);
};

export const playCoinSound = (muted) => {
    if (muted) return;
    soundManager.playRandomCoin();
};

export const playCoinRainSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('coinrain', 0.5); 
};

export const playGhostSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('ghost', 1.0); 
};

export const playBlingSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('bling', 0.8);
};

export const playGridLevelUpSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('levelup', 1.2);
};

// --- UI Sounds ---

export const playUiHoverSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('uiHover', 0.3);
};

export const playUiOpenSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('uiOpen', 0.6);
};

export const playUiConfirmSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('uiConfirm', 0.6);
};

export const playUiCloseSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('uiClose', 0.5);
};

// --- New Logic: Random Click & Specific Actions ---

export const playUiClickSound = (muted) => {
    if (muted) return;
    // Randomly select click1 or click2
    const clicks = ['click1', 'click2'];
    const randomClick = clicks[Math.floor(Math.random() * clicks.length)];
    soundManager.playSFX(randomClick, 0.5);
};

export const playEquipSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('equip', 0.7);
};

export const playCashRegisterSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('cashregister', 0.7);
}; 

// --- Missing Function Added Below ---

export const playUiPauseSound = (muted) => {
    if (muted) return;
    soundManager.playSFX('uiPause', 0.5);
};